import { BaseFieldView } from '../BaseField/views';
import { EmailAddresses } from './models';

export const EmailFieldViewItem = Backbone.Marionette.ItemView.extend({
    template: '#tpl_email_field_item',
    model: null, // EmailAddress
    className: 'email_value_wrapper',

    events: {
        'change input': 'set_email',
        'change select': 'set_email',
        'click .reset_value': 'reset_value'
    },

    initialize: function (options) {
        Backbone.Validation.unbind(this);
        Backbone.Validation.bind(this);

        var this_ = this;
        this.model.unbind('validated:invalid');
        this.model.bind('validated:invalid', function (model, error) {
            this_.$el.addClass('invalid');
        });
        this.model.unbind('validated:valid');
        this.model.bind('validated:valid', function (model, error) {
            this_.$el.removeClass('invalid');
        });
    },

    onRender: function () {
        if (this.model.get('email')) {
            this.$el.find('input, select').addClass('has_value');
        }

        if (!this.model.isValid(true)) {
            this.$el.addClass('invalid');
        }
    },

    onBeforeClose: function () {
        Backbone.Validation.unbind(this);
    },

    set_email: function (event) {
        var val = $(event.target).val();
        this.model.set('email', val); // set, even if invalid - we'll validate next
        this.render();
        if (this.model.validate) {
            this.model.validate();
        }
        return false;
    },

    reset_value: function () {
        this.model.set({
            email: null,
            possible_emails: []
        });

        if (this.model.collection.length == 1) {
            // do not close view if this is the last field
            this.render();
            return false;
        }

        this.model.collection.remove(this.model);
        this.close();
        return false;
    }
});

export const EmailFieldViewItems = Backbone.Marionette.CollectionView.extend({
    itemView: EmailFieldViewItem,
    collection: null // EmailAddresses
});

export const EmailFieldView = BaseFieldView.extend({
    model: null,

    regions: {
        r_emails_list: '.emails_list'
    },

    events: {
        'change input': 'save_value',
        'change select': 'save_value',
        'click .add_email': 'add_email',
        'keydown input': 'on_email_field_keydown'
    },

    initialize: function (options) {
        EmailFieldView.__super__.initialize.apply(this, arguments);
        var this_ = this;

        // Unload our email list string from model.get('value') and turn it into a collection
        this.model.emails_collection = new EmailAddresses();

        var raw_emails = this.model.get('value') ? this.model.get('value').split(',') : [];
        $.each(raw_emails, function (i, email) {
            this_.model.emails_collection.add({ email: email });
        });

        this.listenTo(this.model.emails_collection, 'change add remove', this.save_value);
    },

    onBeforeRender: function () {
        this.model.emails_collection.remove(this.model.emails_collection.where({ email: null }));
        this.model.emails_collection.remove(this.model.emails_collection.where({ email: '' }));

        if (this.model.emails_collection.length == 0) {
            this.model.emails_collection.add({});
        }
    },

    onRender: function () {
        this.r_emails_list.show(new EmailFieldViewItems({ collection: this.model.emails_collection }));
    },

    /**
     * Because our EmailAddresses validate and highlight themselves
     * when things go wrong, we don't need to highlight everything like other fields. Instead,
     * let's just highlight the field name and let the sub-models highlight which individual
     * emails are invalid.
     */
    on_model_invalid: function (model, error) {
        this.model.is_valid = false;
        this.trigger('request_error_wizard_recalculation', this.model);

        // If our submodels validate successfully, this error came from the field being required.
        if (this.model.emails_collection.is_valid()) {
            this.$el.addClass('invalid');
            return;
        }

        this.$el.find('.field_title').addClass('invalid');
    },
    on_model_valid: function (model) {
        this.$el.removeClass('invalid');
        this.model.is_valid = true;
        this.$el.find('.field_title').removeClass('invalid');
        this.trigger('request_error_wizard_recalculation', this.model);
    },

    save_value: function () {
        var values = [];
        this.model.emails_collection.each(function (model, i) {
            if (!model.get('email')) {
                return true;
            }
            values.push(model.get('email'));
        });

        if (this.model.get('value') == values.join(',')) {
            return;
        }

        this.model.set('value', values.join(','));
    },

    add_email: function (event, no_focus) {
        if (this.$el.find('input[value=""]').not($('input:focus')).length == 0) {
            this.model.emails_collection.add({});
        }

        if (!no_focus) {
            this.$el.find('.email_value').last().focus();
        }
        return false;
    },

    on_email_field_keydown: function (event) {
        if (event.keyCode != 188 && event.keyCode != 13) {
            return true;
        } // comma || enter

        this.add_email();
        return false;
    },

    handle_change: function () {} // don't re-render on save; sub-view's will do that themselves
});
